/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Quima_backend
 * OpenAPI spec version: v1
 */
import axios from 'axios';
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  ChangePasswordRequestDto,
  CreateCuratorInviteDto,
  CreateUserRequestDto,
  EmailChangeDto,
  GetApiUserFacebookResponseParams,
  GetApiUserGetUserIdByTokenParams,
  GetApiUserGoogleResponseParams,
  GetApiUserRecreateTokenParams,
  GetApiUserVerifyEmailChangeParams,
  GetApiUserVerifyEmailParams,
  PostApiUserSignupParams,
  ResetPasswordDto,
  ResetPasswordRequestDto,
  UpdateUserRequestDto,
  UserLoginRequestDto,
  VerifyTokenRequestDto
} from '../generated.schemas';




  export const getUser = (axiosInstance: AxiosInstance = axios) => {
const postApiUserSignup = (
    createUserRequestDto: CreateUserRequestDto,
    params?: PostApiUserSignupParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/User/signup`,
      createUserRequestDto,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Creates a curator invite for the given email. Only admins can call this.
The returned token must be used by the invitee during signup to obtain the CURATOR role.
 */
const postApiUserCuratorInvite = (
    createCuratorInviteDto: CreateCuratorInviteDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/User/curator-invite`,
      createCuratorInviteDto,options
    );
  }
/**
 * @summary Retrieves all users and their associated sensors.
 */
const getApiUser = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/User`,options
    );
  }
/**
 * @summary Retrieves a user by their ID.
 */
const getApiUserId = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/User/${id}`,options
    );
  }
/**
 * @summary Updates an existing user by ID.
 */
const putApiUserId = (
    id: number,
    updateUserRequestDto: UpdateUserRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.put(
      `/api/User/${id}`,
      updateUserRequestDto,options
    );
  }
/**
 * @summary Creates a new user.
 */
const postApiUserCreateusrRole = (
    role: string,
    createUserRequestDto: CreateUserRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/User/createusr/${role}`,
      createUserRequestDto,options
    );
  }
/**
 * @summary Deletes a user by ID.
 */
const deleteApiUserDeleteId = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.delete(
      `/api/User/delete/${id}`,options
    );
  }
/**
 * @summary Authenticates a user and returns a JWT token.
 */
const postApiUserLogin = (
    userLoginRequestDto: UserLoginRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/User/login`,
      userLoginRequestDto,options
    );
  }
/**
 * @summary Resets the user's password using a token.
 */
const postApiUserResetPassword = (
    resetPasswordDto: ResetPasswordDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/User/reset-password`,
      resetPasswordDto,options
    );
  }
/**
 * @summary Verifies the user's email using a token.
 */
const getApiUserVerifyEmail = (
    params?: GetApiUserVerifyEmailParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/User/verify-email`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Requests a password reset by sending a reset link to the user's email.
 */
const postApiUserRequestResetPassword = (
    resetPasswordRequestDto: ResetPasswordRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/User/request-reset-password`,
      resetPasswordRequestDto,options
    );
  }
/**
 * @summary Changes the user's password.
 */
const postApiUserChangePassword = (
    changePasswordRequestDto: ChangePasswordRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/User/change-password`,
      changePasswordRequestDto,options
    );
  }
const postApiUserChangeEmail = (
    emailChangeDto: EmailChangeDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/User/change-email`,
      emailChangeDto,options
    );
  }
const getApiUserVerifyEmailChange = (
    params?: GetApiUserVerifyEmailChangeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/User/verify-email-change`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Sends a verification email to the user.
 */
const getApiUserSentVerificationEmail = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/User/sent-verification-email`,options
    );
  }
/**
 * @summary Logs out the user by clearing the authentication cookie and removing the JWT token from the database.
 */
const postApiUserLogoutuser = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/User/logoutuser`,undefined,options
    );
  }
/**
 * @summary Initiates the Google OAuth connection and redirects to Google for authentication.
 */
const getApiUserGoogleLoginRole = (
    role: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/User/google-login/${role}`,options
    );
  }
/**
 * @summary Handles the response from Google after authentication and processes the user's information.
 */
const getApiUserGoogleResponse = (
    params?: GetApiUserGoogleResponseParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/User/google-response`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Logs out the user and redirects them to the Swagger UI.
 */
const getApiUserGoogleLogout = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/User/google-logout`,options
    );
  }
const getApiUserFacebookLoginRole = (
    role: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/User/facebook-login/${role}`,options
    );
  }
const getApiUserFacebookResponse = (
    params?: GetApiUserFacebookResponseParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/User/facebook-response`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary to do expire time check
 */
const getApiUserGetUserIdByToken = (
    params?: GetApiUserGetUserIdByTokenParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/User/get-userId-by-token`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Recreates a social login token for a user.
 */
const getApiUserRecreateToken = (
    params?: GetApiUserRecreateTokenParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/User/recreate-token`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Verifies a JWT token and returns user information if valid.
 */
const postApiUserVerifyToken = (
    verifyTokenRequestDto: VerifyTokenRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/User/verify-token`,
      verifyTokenRequestDto,options
    );
  }
/**
 * @summary Returns the authenticated user's role from the JWT auth context.
Requires a valid Bearer token in the Authorization header.
 */
const getApiUserMe = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/User/me`,options
    );
  }
return {postApiUserSignup,postApiUserCuratorInvite,getApiUser,getApiUserId,putApiUserId,postApiUserCreateusrRole,deleteApiUserDeleteId,postApiUserLogin,postApiUserResetPassword,getApiUserVerifyEmail,postApiUserRequestResetPassword,postApiUserChangePassword,postApiUserChangeEmail,getApiUserVerifyEmailChange,getApiUserSentVerificationEmail,postApiUserLogoutuser,getApiUserGoogleLoginRole,getApiUserGoogleResponse,getApiUserGoogleLogout,getApiUserFacebookLoginRole,getApiUserFacebookResponse,getApiUserGetUserIdByToken,getApiUserRecreateToken,postApiUserVerifyToken,getApiUserMe}};
export type PostApiUserSignupResult = AxiosResponse<void>
export type PostApiUserCuratorInviteResult = AxiosResponse<void>
export type GetApiUserResult = AxiosResponse<void>
export type GetApiUserIdResult = AxiosResponse<void>
export type PutApiUserIdResult = AxiosResponse<void>
export type PostApiUserCreateusrRoleResult = AxiosResponse<void>
export type DeleteApiUserDeleteIdResult = AxiosResponse<void>
export type PostApiUserLoginResult = AxiosResponse<void>
export type PostApiUserResetPasswordResult = AxiosResponse<void>
export type GetApiUserVerifyEmailResult = AxiosResponse<void>
export type PostApiUserRequestResetPasswordResult = AxiosResponse<void>
export type PostApiUserChangePasswordResult = AxiosResponse<void>
export type PostApiUserChangeEmailResult = AxiosResponse<void>
export type GetApiUserVerifyEmailChangeResult = AxiosResponse<void>
export type GetApiUserSentVerificationEmailResult = AxiosResponse<void>
export type PostApiUserLogoutuserResult = AxiosResponse<void>
export type GetApiUserGoogleLoginRoleResult = AxiosResponse<void>
export type GetApiUserGoogleResponseResult = AxiosResponse<void>
export type GetApiUserGoogleLogoutResult = AxiosResponse<void>
export type GetApiUserFacebookLoginRoleResult = AxiosResponse<void>
export type GetApiUserFacebookResponseResult = AxiosResponse<void>
export type GetApiUserGetUserIdByTokenResult = AxiosResponse<void>
export type GetApiUserRecreateTokenResult = AxiosResponse<void>
export type PostApiUserVerifyTokenResult = AxiosResponse<void>
export type GetApiUserMeResult = AxiosResponse<void>
